import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";

import { DataService_discipline } from "./shared/data.service";

import { wsDisciplineDataParm } from "./shared/ws-discipline-info";
import { wsDisciplineDataInfo } from "./shared/ws-discipline-info";
import { wsDisciplineInfo } from "./shared/ws-discipline-info";
import { wsDisciplineIncidentDeleteParm } from "./shared/ws-discipline-info";

import { DisciplineAddEditBasicComponent } from "./disciplineaddeditbasic/disciplineaddeditbasic.component";
import { DisciplineAddEditAdvancedComponent } from "./disciplineaddeditadvanced/disciplineaddeditadvanced.component";
import { DisciplinePrintComponent } from "./disciplineprint/disciplineprint.component";

import { ViewChild } from "@angular/core";
import * as moment from "moment";
import { Router } from "@angular/router";

@Component({
	selector: "app-root",
	templateUrl: "./discipline.component.html",
	styleUrls: ["./discipline.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class DisciplineComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterContinueAlertDesc", { static: false })
	public filterContinueAlertDesc: Dropdown;

	constructor(
		private dataService: DataService_discipline,
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		private router: Router
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public ErrorMessage: string = "";

	//	Person Selector
	private subscriptionPersonSelect: Subscription;
	public SelectedPerson: any; // From Person Selector

	//	DateRange Selector
	public lstDateRange: any = [];
	public SelectedDateRange: any;

	public IncidentData: wsDisciplineDataInfo;

	//	Incident List
	public lstIncident: wsDisciplineInfo[] = [];
	public SelectedIncident: wsDisciplineInfo;

	//	Filters
	public lstContinueAlertDescs: any = [];

	//	UI Data
	public rInited: boolean = false;
	public rEnableAdvancedMode: boolean;
	public rSBMEnabledSchool: boolean = false;
	public rUserHasSBMRole: boolean = false;
	public rSBMLink: string = "";
	public rStartDate: Date = new Date();
	public rEndDate: Date = new Date();
	public rDRTotalDays: number;
	public rDRPresent: number;
	public rDROnTime: number;
	public rDRTardy: number;
	public rDRAbsent: number;
	public rDRCut: number;
	public rDRSuspension: number;
	public rDRPresentPCT: number;
	public rDROnTimePCT: number;
	public rDRAbsentPCT: number;
	public rDRTardyPCT: number;

	//	Incident Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		//
		//	Set DateRange Selector
		//
		this.lstDateRange = [
			{ DateRangeID: 1, DateRangeDesc: "Today", LastXMonths: 0 },
			{ DateRangeID: 2, DateRangeDesc: "Last Month", LastXMonths: 1 },
			{ DateRangeID: 3, DateRangeDesc: "Last 2 Months", LastXMonths: 2 },
			{ DateRangeID: 4, DateRangeDesc: "Last 3 Months", LastXMonths: 3 },
			{
				DateRangeID: 5,
				DateRangeDesc: "Current School Year",
				LastXMonths: 99,
			},
			{
				DateRangeID: 6,
				DateRangeDesc: "Custom Date Range",
				LastXMonths: -1,
			},
			{ DateRangeID: 7, DateRangeDesc: "All", LastXMonths: 1200 },
		];

		this.SelectedDateRange = this.lstDateRange[0];

		//
		//	Init Person Selector
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.onRefresh();
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.ErrorMessage = "";

		let StartDateParm = new Date();
		StartDateParm.setHours(0, 0, 0, 0); // Clear Hours

		let EndDateParm = new Date();
		EndDateParm.setHours(0, 0, 0, 0); // Clear Hours

		if (this.SelectedDateRange.DateRangeID == 6) {
			// Custom Date Range
			if (this.rStartDate == null) {
				this.ErrorMessage = "Invalid Start Date";
				return;
			} else {
				StartDateParm = this.rStartDate;
				StartDateParm.setHours(0, 0, 0, 0); // Clear Hours
			}

			if (this.rEndDate == null) {
				this.ErrorMessage = "Invalid End Date";
				return;
			} else {
				EndDateParm = this.rEndDate;
				EndDateParm.setHours(0, 0, 0, 0); // Clear Hours
			}

			if (this.rStartDate > this.rEndDate) {
				this.ErrorMessage = "Start Date cannot be greater than End Date";
				return;
			}
		}

		//
		//	Get Incident Totals and List
		//
		if (this.SelectedPerson.PersonID > 0) {
			let parm: wsDisciplineDataParm = {
				PersonID: this.SelectedPerson.PersonID,
				LastXMonths: this.SelectedDateRange.LastXMonths,
				StartDate: StartDateParm,
				EndDate: EndDateParm,
			};

			this.isBusy = true;
			this.dataService.DisciplineIncidentGetData(parm).subscribe((data) => this.DisciplineIncidentGetData_Complete(data));
		} else {
			this.lstIncident = [];
			this.SelectedIncident = null;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineIncidentGetData_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineIncidentGetData_Complete(data: any) {
		this.SelectedIncident = null;

		this.IncidentData = data;
		this.lstIncident = this.IncidentData.DisciplineItems;

		this.rEnableAdvancedMode = this.IncidentData.EnableAdvancedMode;
		this.rSBMEnabledSchool = this.IncidentData.SBMEnabledSchool;
		this.rUserHasSBMRole = this.IncidentData.UserHasSBMRole;
		this.rSBMLink = this.IncidentData.SBMLink;
		this.rDRTotalDays = this.IncidentData.DRTotalDays;
		this.rDRPresent = this.IncidentData.DRPresent;
		this.rDROnTime = this.IncidentData.DROnTime;
		this.rDRTardy = this.IncidentData.DRTardy;
		this.rDRAbsent = this.IncidentData.DRAbsent;
		this.rDRCut = this.IncidentData.DRCut;
		this.rDRSuspension = this.IncidentData.DRSuspension;
		this.rDRPresentPCT = this.IncidentData.DRPresentPCT;
		this.rDROnTimePCT = this.IncidentData.DROnTimePCT;
		this.rDRAbsentPCT = this.IncidentData.DRAbsentPCT;
		this.rDRTardyPCT = this.IncidentData.DRTardyPCT;

		//
		//	Set Filter Lists
		//
		this.lstContinueAlertDescs = Array.from(new Set(this.lstIncident.map((item: any) => item.ContinueAlertDesc)));

		//
		//	Set Filter Defaults
		//
		this.onSetFilterDefaults();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "IncidentDT", order: -1 }); // DESC
		this.mydt.sortMultiple();

		this.isBusy = false;

		this.rInited = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetFilterDefaults
	//
	//-----------------------------------------------------------------------------------------------------
	onSetFilterDefaults() {
		//this.mydt.filters.ContinueAlertDesc['value'] = "Yes";			// Default To 'Yes'
		this.mydt.filters.ContinueAlertDesc["value"] = null; // Default To 'Any'
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowDblClick
	//
	//-----------------------------------------------------------------------------------------------------
	onRowDblClick(item: any) {
		if (item.InfractionCount > 1 || item.PenaltyCount > 1) {
			if (this.rEnableAdvancedMode == true) {
				this.onEditAdvanced();
			} else {
				this.onEditBasic();
			}
		} else {
			this.onEditBasic();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEditBasic
	//
	//-----------------------------------------------------------------------------------------------------
	onEditBasic() {
		this.ErrorMessage = "";

		if (this.SelectedPerson == null || this.SelectedPerson <= 0) {
			this.ErrorMessage = "Please select a student.";
			return;
		}

		if (this.SelectedIncident == null) {
			this.ErrorMessage = "Please select a discipline to edit.";
			return;
		}

		if (this.SelectedIncident != null && this.SelectedIncident.IncidentID > 0) {
			let popup_header = "Edit Discipline (Basic Mode)";

			var ref = this.dialogService.open(DisciplineAddEditBasicComponent, {
				header: popup_header,
				width: "1000px",
				data: {
					UserID: this.user.userID,
					UserLevelID: this.user.UserLevelID,
					PersonID: this.SelectedPerson.PersonID,
					IncidentID: this.SelectedIncident.IncidentID,
					SchoolID: this.SelectedPerson.SchoolID,
					isAdd: false,
				},
			});

			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddBasic
	//
	//-----------------------------------------------------------------------------------------------------
	onAddBasic() {
		this.ErrorMessage = "";

		if (this.SelectedPerson == null || this.SelectedPerson.PersonID <= 0) {
			this.ErrorMessage = "Please select a student.";
			return;
		}

		let popup_header = "Add Discipline (Basic Mode)";

		var ref = this.dialogService.open(DisciplineAddEditBasicComponent, {
			header: popup_header,
			width: "1000px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
				PersonID: this.SelectedPerson.PersonID,
				IncidentID: -1,
				SchoolID: this.SelectedPerson.SchoolID,
				isAdd: true,
			},
		});

		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEditAdvanced
	//
	//-----------------------------------------------------------------------------------------------------
	onEditAdvanced() {
		this.ErrorMessage = "";

		if (this.SelectedPerson == null || this.SelectedPerson <= 0) {
			this.ErrorMessage = "Please select a student.";
			return;
		}

		if (this.SelectedIncident == null) {
			this.ErrorMessage = "Please select a discipline to edit.";
			return;
		}

		if (this.SelectedIncident != null && this.SelectedIncident.IncidentID > 0) {
			let popup_header = "Edit Discipline (Advanced Mode)";
			let popup_WidthInt = window.innerWidth - 24; // (give 12px on left and right)
			let popup_Width = popup_WidthInt.toString() + "px";

			var ref = this.dialogService.open(DisciplineAddEditAdvancedComponent, {
				header: popup_header,
				width: popup_Width,
				data: {
					UserID: this.user.userID,
					UserLevelID: this.user.UserLevelID,
					PersonID: this.SelectedPerson.PersonID,
					IncidentID: this.SelectedIncident.IncidentID,
					SchoolID: this.SelectedPerson.SchoolID,
					isAdd: false,
				},
			});

			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddAdvanced
	//
	//-----------------------------------------------------------------------------------------------------
	onAddAdvanced() {
		this.ErrorMessage = "";

		if (this.SelectedPerson == null || this.SelectedPerson.PersonID <= 0) {
			this.ErrorMessage = "Please select a student.";
			return;
		}

		let popup_header = "Add Discipline (Advanced Mode)";
		let popup_WidthInt = window.innerWidth - 24; // (give 12px on left and right)
		let popup_Width = popup_WidthInt.toString() + "px";

		var ref = this.dialogService.open(DisciplineAddEditAdvancedComponent, {
			header: popup_header,
			width: popup_Width,
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
				PersonID: this.SelectedPerson.PersonID,
				IncidentID: -1,
				SchoolID: this.SelectedPerson.SchoolID,
				isAdd: true,
			},
		});

		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDelete
	//
	//-----------------------------------------------------------------------------------------------------
	onDelete() {
		this.ErrorMessage = "";

		if (this.SelectedIncident == null) {
			this.ErrorMessage = "Please select a discipline to delete.";
			return;
		}

		//
		// Confirm Delete
		//
		var message =
			"You are about to remove a discipline with infraction '" +
			this.SelectedIncident.InfractionDesc +
			"' entered on " +
			moment(this.SelectedIncident.IncidentDT).format("MMM d, YYYY, h:mm a") +
			". <br><br>" +
			"Do you wish to continue?";

		this.confirmationService.confirm({
			message: message,
			header: "Delete Discipline",
			icon: "fa fa-info",
			accept: () => {
				this.onDeleteConfirmed();
			},
			reject: () => {},
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDeleteConfirmed
	//
	//-----------------------------------------------------------------------------------------------------
	onDeleteConfirmed() {
		let parms: wsDisciplineIncidentDeleteParm = {
			IncidentID: this.SelectedIncident.IncidentID,
		};

		this.isBusy = true;
		this.dataService.DisciplineIncidentDelete(parms).subscribe((data) => this.DisciplineIncidentDelete_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineIncidentDelete_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineIncidentDelete_Complete(data: any) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		this.ErrorMessage = "";

		if (this.SelectedIncident == null) {
			this.ErrorMessage = "Please select a discipline to print.";
			return;
		}

		//
		//	Display Print Popup
		//
		var ref = this.dialogService.open(DisciplinePrintComponent, {
			header: "Print",
			width: "435px",
			data: {
				UserPersonID: this.user.personID,
				UserID: this.user.userID,
				IncidentID: this.SelectedIncident.IncidentID,
				PersonID: this.SelectedPerson.PersonID,
				StartDate: this.IncidentData.StartDate,
				EndDate: this.IncidentData.EndDate,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddSBMIncident
	//
	//-----------------------------------------------------------------------------------------------------
	onAddSBMIncident() {
		var fullLink = String(this.rSBMLink);
		var user = this.userService.getCurrentUser();
		var JsonStr = JSON.stringify(user);
		var UserB64 = btoa(JsonStr);

		fullLink = fullLink + UserB64;

		var a = document.createElement("a");
		a.href = fullLink;
		a.target = "_blank";
		a.click();
		//this.router.navigate([fullLink]);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedIncident here. We don't unselect when selected.
		//
		this.SelectedIncident = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDateRangeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onDateRangeChange(value) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDateChange(val) {
		this.rStartDate = val;
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDateChange(val) {
		this.rEndDate = val;
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
